import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ICityDto } from '@models/city-dto';
import { IPage } from '@models/pagination/page';
import { IAttachmentDto } from '@models/portal/users/dtos/attachment-dto';
import { IContactDto } from '@models/portal/users/dtos/contact-dto';
import { IDocumentDto } from '@models/portal/users/dtos/document-dto';
import { ITeachingInstitutionDto } from '@models/teaching-institution-dto';
import { CityService } from '@shared/services/city.service';
import { TeachingInstitutionService } from '@shared/services/teaching-institution.service';
import { AttachmentTypeDto, TypeAttachmentService } from '@shared/services/type-attachment.service';
import { IPublicPlaceDto, UserEventDto, UserEventService } from '@shared/services/user-event.service';
import { map } from 'rxjs';

@Component({
  selector: 'sigecom-modal-participante',
  templateUrl: './modal-participante.component.html'
})
export class ModalParticipanteComponent implements OnInit {
  
  readonly userEventService = inject(UserEventService);
  readonly cityService = inject(CityService);
  readonly teachingInstitutionService = inject(TeachingInstitutionService);
  readonly typeAttachmentService = inject(TypeAttachmentService);

  @Input() atlNrId!: number;

  abaSelecionadaParticipantView = 'Dados Cadastrais'
  dataViewStyle = 'flex flex-col pl-2 items-start gap-3 min-w-[50rem] min-h-[10rem]';
  userEvent?: UserEventDto;
  userContact?: IPage<IContactDto>;
  userPublicPlace?: IPublicPlaceDto;
  userDataCity?: ICityDto;
  userDocument?: IPage<IDocumentDto>;

  userAttachment?: IPage<IAttachmentDto>;
  iTeachingInstitutionDto?: ITeachingInstitutionDto;
  typeAttachementUser: AttachmentTypeDto[] = [];

  ngOnInit(): void {
    console.log(this.atlNrId)
    this.openViewDataRegistered(this.atlNrId);
  }

  openViewDataRegistered(usuNrId: number) {
  
    this.userEventService.replicateDataToEventUser$(usuNrId, 15)
      .pipe(
        map(value => {
          if (value.insNrId) {
            this.teachingInstitutionService.getInstitutionById$(value.insNrId).subscribe(value => this.iTeachingInstitutionDto = value);
          }
          this.userEvent = value;
        })
      ).subscribe();

    this.userEventService.searchUserContactsEvent$(usuNrId, 15).subscribe(res => this.userContact = res);
    this.userEventService.searchPublicPlaceUserEvent$(usuNrId, 15).subscribe({
      next: res => {
        this.userPublicPlace = res;
        this.cityService.getCityById$(res.cidNrId!).subscribe(data => this.userDataCity = data);
      },
    });
    this.userEventService.searchDocumentUserEvent$(usuNrId, 15).subscribe(res => this.userDocument = res);
    this.userEventService.searchAttachmentsUserEvent$(usuNrId, 15).subscribe({
      next: res => this.userAttachment = res,
      complete: () => {
        if (this.userAttachment?.content) {
          for (let i of this.userAttachment?.content) {
            this.typeAttachmentService.getAttachmentType$(i.tipNrId!).subscribe(
              data => this.typeAttachementUser.push(data)
            )
          }
        }
      }
    });
  };
}
